{
  "id": "eye-embedding",
  "comment": [
    "Published releases of the eye-embedding model, oldest first; the last entry is current.",
    "Policy: every published version stays served, indefinitely. A versioned URL that stops",
    "resolving is worse than one never published, because it is already in someone's methods",
    "section -- and 20 MB per version on GitHub's own infrastructure is not a cost worth",
    "optimising. `served: false` is for a version withdrawn on purpose, not for tidying up.",
    "Layout: the current model sits at models/eye_embedding.onnx (assets.ts resolves exactly",
    "that path for bundler users); superseded versions live at models/<version>/. Each",
    "release's `file` names where its bytes actually are.",
    "contractHash is sha256 over everything a browser must implement -- the whole preprocess",
    "block, the ONNX I/O and the embedding dim. It is what decides major vs minor: the",
    "registry recorded the I/O but not the preprocessing, so half the question was",
    "unanswerable from here alone. Opset is deliberately outside it (it changes what can",
    "load the file, not what the runtime implements) and is flagged for a person.",
    "Produced by web/export in jspsych/eye-tracking; see that repo's ARCHITECTURE.md."
  ],
  "releases": [
    {
      "version": "1.0.0",
      "date": "2026-09-09",
      "served": true,
      "file": "eye_embedding.onnx",
      "sha256": "5a1a111e37f97bd50fcffccbf6498bf377700d27cd4e3ea5bc5d237541a3c73a",
      "bytes": 20626568,
      "contract": 1,
      "contractHash": "sha256:7b5b781d45f7e666a5ed02968bad3854d4910dccc4039b55f1c59f6fe1047799",
      "io": {
        "input": {
          "name": "eye_image",
          "shape": [1, 36, 144, 1],
          "dtype": "float32"
        },
        "output": {
          "name": "embedding",
          "shape": [1, 128],
          "dtype": "float32"
        },
        "inputRange": "uint8_0_255",
        "opset": 17,
        "weightOutput": {
          "name": "cal_weight",
          "shape": [1, 1],
          "dtype": "float32",
          "range": "sigmoid_0_1",
          "granularity": "per_image"
        }
      },
      "provenance": {
        "wandb": "vassar-cogsci-lab/eye-tracking-multiframe/kwppnkuj",
        "checkpoint": "multiframe_random_s42_ext70.weights.h5",
        "exportedAt": "2026-09-09T20:02:34Z",
        "toolchain": {
          "keras": "3.14.1",
          "tensorflow": "2.20.0",
          "tf2onnx": "1.16.1",
          "onnx": "1.17.0"
        }
      },
      "notes": "First public model. Hybrid backbone, embedding_dim 128, token_pool_extra 1. Two outputs: the embedding, and a per-frame calibration weight (sigmoid, [0,1]) from the trained Calibration_Weights head. The embedding is bit-identical to the pre-release export that carried only one output."
    }
  ]
}
